/** When your routing table is too long, you can split it into small modules **/

// import Layout from '@/layout'

const settingsRouter = {
  path: '/settings',
  component: () => import('@/views/base/Index'),
  children: [
    {
      name: '系统账号',
      path: 'users',
      component: () => import('@/views/settings/users'),
    },
    {
      name: '楼层积差',
      path: 'feefloats',
      component: () => import('@/views/settings/feefloats'),
    },
    {
      name: '过渡费日期',
      path: 'feedate',
      component: () => import('@/views/settings/transitionFeeSettiong'),
    },
  ],
}

export default settingsRouter
